import React from "react";

const ShopDetailSkeleton = () => {
  return (
    <div className="flex min-h-[65vh] w-full items-center justify-center bg-lightPastelPurple px-4 py-14">
      <style>
        {`
          @keyframes themeLoaderSpin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }

          @keyframes themeLoaderPulse {
            0%, 100% {
              opacity: 0.45;
              transform: scale(0.95);
            }
            50% {
              opacity: 1;
              transform: scale(1.05);
            }
          }

          @keyframes themeLoaderFadeUp {
            from {
              opacity: 0;
              transform: translateY(12px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      <div
        className="relative flex w-full max-w-[360px] flex-col items-center overflow-hidden rounded-[30px] border border-pastelPurple bg-white px-8 py-9 text-center shadow-[0_22px_60px_rgba(47,34,84,0.10)]"
        style={{
          animation: "themeLoaderFadeUp 0.35s ease both",
        }}
      >
        <div className="absolute -left-16 -top-16 h-44 w-44 rounded-full bg-pastelPurple/70 blur-3xl"></div>
        <div className="absolute -right-16 -bottom-16 h-44 w-44 rounded-full bg-keyLime/25 blur-3xl"></div>

        <div className="relative flex h-20 w-20 items-center justify-center rounded-[24px] border border-pastelPurple bg-lightPastelPurple shadow-sm">
          <div
            className="absolute h-14 w-14 rounded-full bg-keyLime/25"
            style={{
              animation: "themeLoaderPulse 1.35s ease-in-out infinite",
            }}
          ></div>

          <div
            className="relative h-12 w-12 rounded-full border-[5px] border-pastelPurple border-t-keyLime"
            style={{
              animation: "themeLoaderSpin 0.9s linear infinite",
            }}
          ></div>
        </div>

        <h3 className="relative mt-6 text-xl font-extrabold text-darkPurple">
          Loading Product
        </h3>

        <p className="relative mt-2 text-sm font-medium leading-6 text-[#5f5870]">
          Please wait a moment
        </p>
      </div>
    </div>
  );
};

export default ShopDetailSkeleton;